import React from 'react';
import styled from 'styled-components';

import { getTranslatedString } from 'helpers/i18n';

import Spacer from 'components/ui/Spacer';
import ResidentCard from './ResidentCard';

const StyledResidentList = styled.div`
  margin-bottom: 40px;
`;

const FormTitle = styled.span`
  font-size: 20px;
  font-family: 'Circular-Bold';
`;

const ResidentList = ({ residents }) => {
  if (!residents || !residents.length) {
    return null;
  }
  return (
    <StyledResidentList>
      <Spacer mb={1}>
        <FormTitle>{getTranslatedString('landlordPortal.maintenance.tickets.residents')}</FormTitle>
      </Spacer>
      {(residents || []).map(resident => (
        <ResidentCard key={`resident-${resident.id}`} resident={resident} />
      ))}
    </StyledResidentList>
  );
};

export default ResidentList;
